var _path, _path2, _path3, _polygon, _path4, _polygon2, _circle, _polygon3, _polygon4, _rect, _rect2, _rect3, _polygon5, _polygon6, _rect4, _rect5, _polygon7, _polygon8, _rect6, _rect7, _polygon9, _polygon10, _rect8, _rect9, _rect10, _polygon11, _polygon12, _rect11, _rect12, _polygon13, _polygon14, _rect13, _rect14, _polygon15, _polygon16, _rect15, _rect16, _rect17, _polygon17, _polygon18, _rect18, _rect19, _polygon19, _polygon20, _rect20, _rect21, _rect22, _path5, _rect23, _path6, _path7, _rect24, _path8, _rect25, _path9, _polygon21, _path10, _path11, _polygon22, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _circle2, _circle3, _path20, _path21, _path22, _path23, _path24, _polygon23, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _rect26, _rect27, _rect28, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _circle4, _path49, _path50, _path51, _path52, _circle5, _circle6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b41107ec-0743-407f-ab78-90e6ac5363b5",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 1140.7061,
    height: 705.60208,
    viewBox: "0 0 1140.7061 705.60208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "suburbs") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.80493,562.04992c7.21154,13.37413,22.517,19.11535,22.517,19.11535s3.61326-15.94251-3.59829-29.31664-22.517-19.11535-22.517-19.11535S46.59339,548.6758,53.80493,562.04992Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#3f3d56"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7617,557.64993c13.0198,7.83315,18.03414,23.39194,18.03414,23.39194s-16.09494,2.85875-29.11474-4.9744S29.647,552.67553,29.647,552.67553,45.74189,549.81678,58.7617,557.64993Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#e87100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M740.35305,340.17069c0,106.93437-63.57078,144.27185-141.98931,144.27185S456.37442,447.10506,456.37442,340.17069,598.36374,97.199,598.36374,97.199,740.35305,233.23633,740.35305,340.17069Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#f2f2f2"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "563.544 370.886 564.998 281.391 625.518 170.674 565.226 267.352 565.88 227.112 607.59 147.009 566.053 216.463 566.053 216.463 567.229 144.089 611.893 80.317 567.414 132.708 568.148 0 563.532 175.682 563.911 168.435 518.501 98.927 563.183 182.347 558.952 263.176 558.826 261.031 506.476 187.885 558.667 268.61 558.138 278.719 558.043 278.871 558.087 279.701 547.352 484.772 561.694 484.772 563.415 378.848 615.478 298.321 563.544 370.886",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1137.35305,340.17069c0,106.93437-63.57078,144.27185-141.98931,144.27185S853.37442,447.10506,853.37442,340.17069,995.36374,97.199,995.36374,97.199,1137.35305,233.23633,1137.35305,340.17069Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#f2f2f2"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "960.544 370.886 961.998 281.391 1022.518 170.674 962.226 267.352 962.88 227.112 1004.59 147.009 963.053 216.463 963.053 216.463 964.229 144.089 1008.893 80.317 964.414 132.708 965.148 0 960.532 175.682 960.911 168.435 915.501 98.927 960.183 182.347 955.952 263.176 955.826 261.031 903.476 187.885 955.667 268.61 955.138 278.719 955.043 278.871 955.087 279.701 944.352 484.772 958.694 484.772 960.415 378.848 1012.478 298.321 960.544 370.886",
    fill: "#3f3d56"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 109.21582,
    cy: 274.47189,
    r: 54.31516,
    fill: "#ff6584"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "40.303 376.635 32.33 363.346 106.746 299.561 298.103 299.561 298.103 318.165 229.002 392.581 149.27 408.528 40.303 376.635",
    fill: "#3f3d56"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "331.043 336.993 331.043 295.411 305.99 295.411 305.99 308.523 298.103 299.561 234.317 363.346 223.686 373.977 210.398 427.132 234.317 485.602 356.573 485.602 356.573 366.004 331.043 336.993",
    fill: "#ccc"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 32.32973,
    y: 363.34639,
    width: 201.98765,
    height: 122.25569,
    fill: "#f2f2f2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 163.88747,
    y: 401.88351,
    width: 42.52372,
    height: 37.20825,
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 109.40396,
    y: 400.55465,
    width: 37.20825,
    height: 85.04743,
    fill: "#ccc"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "66.88 413.843 66.88 400.555 50.934 400.555 50.934 413.843 65.551 413.843 66.88 413.843",
    fill: "#3f3d56"
  })), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "65.551 424.474 50.934 424.474 50.934 437.763 66.88 437.763 66.88 424.474 65.551 424.474",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 77.51117,
    y: 400.55465,
    width: 15.94639,
    height: 13.28866,
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 77.51117,
    y: 424.47424,
    width: 15.94639,
    height: 13.28866,
    fill: "#3f3d56"
  })), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "291.459 415.172 291.459 401.884 275.512 401.884 275.512 415.172 290.13 415.172 291.459 415.172",
    fill: "#3f3d56"
  })), _polygon8 || (_polygon8 = /*#__PURE__*/React.createElement("polygon", {
    points: "290.13 425.803 275.512 425.803 275.512 439.092 291.459 439.092 291.459 425.803 290.13 425.803",
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 302.08955,
    y: 401.88351,
    width: 15.94639,
    height: 13.28866,
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 302.08955,
    y: 425.8031,
    width: 15.94639,
    height: 13.28866,
    fill: "#3f3d56"
  })), _polygon9 || (_polygon9 = /*#__PURE__*/React.createElement("polygon", {
    points: "423.812 376.562 415.839 363.274 490.256 299.488 681.612 299.488 681.612 318.092 612.511 392.509 532.779 408.455 423.812 376.562",
    fill: "#3f3d56"
  })), _polygon10 || (_polygon10 = /*#__PURE__*/React.createElement("polygon", {
    points: "714.553 336.92 714.553 295.338 689.499 295.338 689.499 308.45 681.612 299.488 617.827 363.274 607.196 373.904 593.907 427.059 617.827 485.529 740.082 485.529 740.082 365.931 714.553 336.92",
    fill: "#ccc"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 415.83919,
    y: 363.27358,
    width: 201.98765,
    height: 122.25569,
    fill: "#f2f2f2"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 547.39694,
    y: 401.81069,
    width: 42.52372,
    height: 37.20825,
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 492.91342,
    y: 400.48183,
    width: 37.20825,
    height: 85.04743,
    fill: "#ccc"
  })), _polygon11 || (_polygon11 = /*#__PURE__*/React.createElement("polygon", {
    points: "450.39 413.77 450.39 400.482 434.443 400.482 434.443 413.77 449.061 413.77 450.39 413.77",
    fill: "#3f3d56"
  })), _polygon12 || (_polygon12 = /*#__PURE__*/React.createElement("polygon", {
    points: "449.061 424.401 434.443 424.401 434.443 437.69 450.39 437.69 450.39 424.401 449.061 424.401",
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 461.02064,
    y: 400.48183,
    width: 15.94639,
    height: 13.28866,
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 461.02064,
    y: 424.40142,
    width: 15.94639,
    height: 13.28866,
    fill: "#3f3d56"
  })), _polygon13 || (_polygon13 = /*#__PURE__*/React.createElement("polygon", {
    points: "674.968 415.099 674.968 401.811 659.022 401.811 659.022 415.099 673.639 415.099 674.968 415.099",
    fill: "#3f3d56"
  })), _polygon14 || (_polygon14 = /*#__PURE__*/React.createElement("polygon", {
    points: "673.639 425.73 659.022 425.73 659.022 439.019 674.968 439.019 674.968 425.73 673.639 425.73",
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 685.59902,
    y: 401.81069,
    width: 15.94639,
    height: 13.28866,
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 685.59902,
    y: 425.73029,
    width: 15.94639,
    height: 13.28866,
    fill: "#3f3d56"
  })), _polygon15 || (_polygon15 = /*#__PURE__*/React.createElement("polygon", {
    points: "795.812 376.562 787.839 363.274 862.256 299.488 1053.612 299.488 1053.612 318.092 984.511 392.509 904.779 408.455 795.812 376.562",
    fill: "#3f3d56"
  })), _polygon16 || (_polygon16 = /*#__PURE__*/React.createElement("polygon", {
    points: "1086.553 336.92 1086.553 295.338 1061.499 295.338 1061.499 308.45 1053.612 299.488 989.827 363.274 979.196 373.904 965.907 427.059 989.827 485.529 1112.082 485.529 1112.082 365.931 1086.553 336.92",
    fill: "#ccc"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 787.83919,
    y: 363.27358,
    width: 201.98765,
    height: 122.25569,
    fill: "#f2f2f2"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 919.39694,
    y: 401.81069,
    width: 42.52372,
    height: 37.20825,
    fill: "#3f3d56"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 864.91342,
    y: 400.48183,
    width: 37.20825,
    height: 85.04743,
    fill: "#ccc"
  })), _polygon17 || (_polygon17 = /*#__PURE__*/React.createElement("polygon", {
    points: "822.39 413.77 822.39 400.482 806.443 400.482 806.443 413.77 821.061 413.77 822.39 413.77",
    fill: "#3f3d56"
  })), _polygon18 || (_polygon18 = /*#__PURE__*/React.createElement("polygon", {
    points: "821.061 424.401 806.443 424.401 806.443 437.69 822.39 437.69 822.39 424.401 821.061 424.401",
    fill: "#3f3d56"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 833.02064,
    y: 400.48183,
    width: 15.94639,
    height: 13.28866,
    fill: "#3f3d56"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 833.02064,
    y: 424.40142,
    width: 15.94639,
    height: 13.28866,
    fill: "#3f3d56"
  })), _polygon19 || (_polygon19 = /*#__PURE__*/React.createElement("polygon", {
    points: "1046.968 415.099 1046.968 401.811 1031.022 401.811 1031.022 415.099 1045.639 415.099 1046.968 415.099",
    fill: "#3f3d56"
  })), _polygon20 || (_polygon20 = /*#__PURE__*/React.createElement("polygon", {
    points: "1045.639 425.73 1031.022 425.73 1031.022 439.019 1046.968 439.019 1046.968 425.73 1045.639 425.73",
    fill: "#3f3d56"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 1057.59902,
    y: 401.81069,
    width: 15.94639,
    height: 13.28866,
    fill: "#3f3d56"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 1057.59902,
    y: 425.73029,
    width: 15.94639,
    height: 13.28866,
    fill: "#3f3d56"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 759.08247,
    y: 406.59746,
    width: 2,
    height: 79,
    fill: "#3f3d56"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M809.18715,513.86406c.12732,27.62433-19.30786,50.10832-19.30786,50.10832s-19.6416-22.30389-19.76892-49.92822,19.30787-50.10833,19.30787-50.10833S809.05984,486.23973,809.18715,513.86406Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#e87100"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 395.08247,
    y: 404.59746,
    width: 2,
    height: 79,
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M445.18715,511.86406c.12732,27.62433-19.30786,50.10832-19.30786,50.10832s-19.6416-22.30389-19.76892-49.92822,19.30787-50.10833,19.30787-50.10833S445.05984,484.23973,445.18715,511.86406Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#e87100"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M445.18715,511.86406c.12732,27.62433-19.30786,50.10832-19.30786,50.10832s-19.6416-22.30389-19.76892-49.92822,19.30787-50.10833,19.30787-50.10833S445.05984,484.23973,445.18715,511.86406Z",
    transform: "translate(-29.64695 -97.19896)",
    opacity: 0.1
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 369.08247,
    y: 404.59746,
    width: 2,
    height: 79,
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M419.18715,511.86406c.12732,27.62433-19.30786,50.10832-19.30786,50.10832s-19.6416-22.30389-19.76892-49.92822,19.30787-50.10833,19.30787-50.10833S419.05984,484.23973,419.18715,511.86406Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#e87100"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 3.7061,
    y: 483.60208,
    width: 1137,
    height: 2,
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M290.77445,520.9614s1.02434,1.1739-.73078,3.44525-.3379,7.2,2.99657,7.32552,4.95149,1.52213,4.14759,3.36181-1.76991,6.21106,1.86146,5.54639,4.77905.781,4.13615,1.89213,1.61924-2.20969,1.61924-2.20969,2.02357,3.0147,4.50726.90435,3.47116-21.2402-1.59222-21.56443S290.77445,520.9614,290.77445,520.9614Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#2f2e41"
  })), _polygon21 || (_polygon21 = /*#__PURE__*/React.createElement("polygon", {
    points: "286.797 514.735 287.95 522.812 293.143 522.812 291.412 513.581 286.797 514.735",
    fill: "#ffb8b8"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M323.36667,615.10736s6.92313,6.3462,5.19235,6.92313-8.077,7.5-9.23084,8.077c-1.032.516-12.11547,4.03849-10.38469,0a15.17381,15.17381,0,0,1,5.76928-6.3462l1.15385-6.92312Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#f2f2f2"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M323.36667,615.10736s6.92313,6.3462,5.19235,6.92313-8.077,7.5-9.23084,8.077c-1.032.516-12.11547,4.03849-10.38469,0a15.17381,15.17381,0,0,1,5.76928-6.3462l1.15385-6.92312Z",
    transform: "translate(-29.64695 -97.19896)",
    opacity: 0.1
  })), _polygon22 || (_polygon22 = /*#__PURE__*/React.createElement("polygon", {
    points: "293.72 508.678 294.874 516.755 300.066 516.755 298.335 507.524 293.72 508.678",
    fill: "#ffb8b8"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M301.67058,584.43614l7.56138-25.00225s-12.6924-11.53855-4.03849-15.00011S316.15508,558.28,316.15508,558.28l-2.88463,30.00022H301.7319Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#ffb8b8"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M319.32818,566.06855s-14.91085,19.12462-12.64777,21.96624,6.30157,20.14945,6.30157,20.14945-.57692,6.92312,1.73079,6.92312,8.077-1.15385,8.077-2.88463-5.19235-23.654-5.19235-23.654l15.00011-19.61553Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#e87100"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M320.482,567.2224l15.00011-8.077s10.38469,5.19235,7.5,9.80776-16.154,16.73089-16.154,16.73089,4.03849,19.61553,3.46156,20.19246-6.92313,2.88463-8.65391,2.30771-10.96161-23.07709-8.65391-24.231,9.80777-13.26932,9.80777-13.26932Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#e87100"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M279.52021,787.9547s10.38469,6.3462,11.53854,6.3462,16.73089,4.03849,9.80776,6.92312-33.46178-1.15385-32.88485-2.88463,0-12.11548,1.15385-12.11548S279.52021,787.9547,279.52021,787.9547Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#2f2e41"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M291.05875,787.03168s10.38469,6.3462,11.53854,6.3462,16.73089,4.03849,9.80777,6.92312-33.46178-1.15385-32.88485-2.88463,0-12.11547,1.15385-12.11547S291.05875,787.03168,291.05875,787.03168Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M279.09713,666.72311s2.73078,15.6539,5.61542,22.0001-.57693,36.34642-2.30771,40.96184-18.46167,59.4235-13.26933,60.00043,15.577,0,15.577,0l16.73089-52.50038L298.5588,666.8Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#575a88"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M279.09713,666.72311s2.73078,15.6539,5.61542,22.0001-.57693,36.34642-2.30771,40.96184-18.46167,59.4235-13.26933,60.00043,15.577,0,15.577,0l16.73089-52.50038L298.5588,666.8Z",
    transform: "translate(-29.64695 -97.19896)",
    opacity: 0.1
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M283.5587,665.3s2.3077,15.577,7.5,19.0386,3.46156,6.92313,3.46156,6.92313L292.2126,721.8389s-22.50016,55.385-15.577,62.30814,13.26933,4.03849,16.154,3.46156,8.077-12.69239,5.19235-16.154,5.76927-24.23094,8.077-27.6925,0-8.077,2.88463-9.23084,9.23084-8.65391,9.23084-13.84625,8.077-60.57736,2.88464-64.03893-38.47491,7.14439-38.47491,7.14439Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#575a88"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 242.95013,
    cy: 474.63886,
    r: 12.6924,
    fill: "#ffb8b8"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 271.79649,
    cy: 428.48468,
    r: 10.38469,
    fill: "#ffb8b8"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M281.251,571.83782s6.92312,12.6924,10.38469,12.6924-13.84626,13.26933-13.84626,13.26933-5.76927-16.73089-6.92312-17.30782S281.251,571.83782,281.251,571.83782Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#ffb8b8"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M283.5587,583.37637s-15.00011,5.19234-14.42319,6.92312-4.03849,5.76927-4.03849,7.50006-1.15385,17.30781,5.76928,30.00021S288.751,649.723,283.5587,655.49227s-13.26933,15.577-4.61542,15.577,22.50016-12.69239,35.19256-8.077,9.80776-12.6924,9.80776-12.6924,1.73078-13.26932-1.73078-17.30781-15.577-32.88485-15.577-36.34642S295.09724,579.9148,292.2126,579.9148,283.5587,583.37637,283.5587,583.37637Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#8985a8"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M301.44344,532.02984",
    transform: "translate(-29.64695 -97.19896)",
    fill: "none",
    stroke: "#2f2e41",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M304.32808,532.02984s4.69793,8.93221,4.94514,10.52384,8.32418-10.52384,8.32418-10.52384l-9.23083-6.3462Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#ffb8b8"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M306.05886,538.953l9.80776-10.38469,11.53855,5.19234s10.7612,23.654,11.43833,25.3848-17.20761,9.80776-18.93839,9.80776-13.84625-17.88474-13.84625-17.88474S303.17422,542.41453,306.05886,538.953Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#f2f2f2"
  })), _polygon23 || (_polygon23 = /*#__PURE__*/React.createElement("polygon", {
    points: "271.796 455.6 271.796 465.985 278.72 465.985 276.443 455.6 271.796 455.6",
    fill: "#ffb8b8"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M305.39348,560.58774a4.3029,4.3029,0,0,0-4.06421,2.73194c-.451,1.21972-.29792,2.50161,1.84495,3.03733,4.61542,1.15386,5.19235,0,5.19235,0s8.0121-1.15385,6.31376-3.46156-6.31376-2.30771-6.31376-2.30771Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#ffb8b8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M330.2898,610.492s6.92313,6.3462,5.19235,6.92312-8.077,7.50006-9.23084,8.077c-1.032.516-12.11547,4.03849-10.38469,0a15.17375,15.17375,0,0,1,5.76927-6.3462l1.15386-6.92312Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#f2f2f2"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M268.07481,562.06781c.79408-.46531,1.73192-1.04482,1.7546-1.96491a1.73936,1.73936,0,0,0-1.14052-1.52791,5.1063,5.1063,0,0,0-1.9937-.26867,2.59484,2.59484,0,0,0-.77078.07639c-.65717.2027-1.03575.87-1.55336,1.32275a6.49032,6.49032,0,0,1-2.7535,1.10148,18.02613,18.02613,0,0,0-4.6148,1.91244,2.1643,2.1643,0,0,0-.73038.60086,2.9468,2.9468,0,0,0-.29342,1.49334c-.13024,1.95743-1.30381,3.6613-2.17991,5.41657s-1.45167,3.94185-.42337,5.61252a19.107,19.107,0,0,1,1.14107,1.61982c.72877,1.51858-.18081,3.38841.34574,4.98839a4.36269,4.36269,0,0,0,1.10462,1.65622,8.77724,8.77724,0,0,0,3.6352,2.201c1.311.40368,2.93764.6727,3.45111,1.94477a10.34042,10.34042,0,0,0,.48608,1.68832,2.674,2.674,0,0,0,1.89554.95105,8.1007,8.1007,0,0,0,2.45567.17772,3.04709,3.04709,0,0,0,2.11828-1.13389,6.19432,6.19432,0,0,1,.8577-1.26487c.83535-.69816,2.10421-.14671,3.17706-.33171a2.32371,2.32371,0,0,0,1.82079-1.709,3.2351,3.2351,0,0,1,.36957-1.30609c.66625-.85259,2.41934-.2507,2.85922-1.23928.28583-.64238-.31217-1.321-.8904-1.721a25.31988,25.31988,0,0,1-2.84245-1.928,3.30867,3.30867,0,0,1-1.20648-3.04778c.397-1.67278,2.58105-2.59384,2.65341-4.31157a3.08862,3.08862,0,0,0-1.45733-2.43357,22.45152,22.45152,0,0,1-2.41663-1.692c-.51727-.50074-.90732-1.12913-1.46962-1.57871a6.89526,6.89526,0,0,0-3.70344-1.04459c-.6947-.0713-3.46578-.39222-3.35677-1.45042C264.49415,563.99865,267.36968,562.481,268.07481,562.06781Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#2f2e41"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M306.05886,538.376s-6.3462,2.30771-6.3462,5.19235-2.88464,12.11547,0,12.11547,8.65391-2.21458,8.65391-2.21458Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#f2f2f2"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M304.32808,579.9148s16.73089-5.76927,17.30781-5.76927,8.65391-4.61542,8.077-6.3462l-2.3077-14.42318s-9.23084-19.0386-2.88464-19.0386,9.80776,15.00011,9.80776,15.00011,13.84626,25.96172,6.3462,31.731-38.65412,16.154-40.3849,14.42318S304.32808,579.9148,304.32808,579.9148Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#ffb8b8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M320.482,542.41453l3.89426,3.75278-5.04812,4.90113s-6.92312-2.88464-6.3462-1.15385,4.0385,6.92312,6.3462,6.92312,14.3183-7.5,14.37074-9.80776-7.44761-10.38469-9.17839-10.96162S320.482,542.41453,320.482,542.41453Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#ffb8b8"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M313.15953,538.39305s8.47636,7.483,9.63022,7.483,3.2523-11.243,3.2523-11.243-6.83912-4.45617-9.37267-3.24123S313.15953,538.39305,313.15953,538.39305Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#f2f2f2"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M283.5587,586.83793s0-8.077,17.30781-8.077h7.50006l-3.46157,19.0386-11.53854,3.46156Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#8985a8"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M321.36543,521.47472a44.79945,44.79945,0,0,1-5.075-.313c-1.32285-3.19677-3.00768-5.87911-4.83022-6.87915a18.27325,18.27325,0,0,0-4.85388-2.66358c-3.84409-1.63311-10.24323-.61449-10.61732,1.24282-7.56413,3.61433-5.65268,9.96169-5.65268,9.96169,1.17531,2.4844,3.81207,1.38333,6.049.25824a4.42013,4.42013,0,0,0,3.85218,3.40207c3.69393.13908,5.48526,1.6862,4.5947,3.72422s-1.96071,6.8806,2.06212,6.14427,5.29423.86521,4.582,2.09611,1.7938-2.44789,1.7938-2.44789,2.24171,3.33969,4.99314,1.00183a2.08825,2.08825,0,0,0,.57322-.98194,4.13559,4.13559,0,0,0,2.86836.50225c3.29568-1.47457,1.24891-4.93714,1.24891-4.93714s4.39977-.67495,2.98209-.56306-2.31453-1.72577.08431-5.038S323.58825,521.54989,321.36543,521.47472Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#2f2e41"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 296.53956,
    y: 518.47205,
    width: 1.73078,
    height: 5.19235,
    transform: "translate(150.10202 -164.44942) rotate(18.40679)",
    fill: "#e87100"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 104.7061,
    y: 703.60208,
    width: 287,
    height: 2,
    fill: "#3f3d56"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 721.7061,
    y: 609.60208,
    width: 287,
    height: 2,
    fill: "#3f3d56"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M963.0629,527.19158l16.12788-3.14691s3.93363-13.37434,8.654-11.80089-3.1469,14.9478-3.1469,14.9478L962.27618,537.419Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#a0616a"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M865.11552,540.56592l-7.08053,9.04735s-10.22744-.39337-7.08053,5.11372,10.22743,2.36017,10.6208,1.18008,11.80089-11.40752,11.80089-11.40752Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#a0616a"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M894.0277,530.1418l5.90045-3.1469s25.17523-1.96682,34.61594,4.327-39.72966,7.08053-39.72966,7.08053Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#e87100"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M905.23855,524.438s-3.14691-7.4739,1.18009-8.26063a19.42065,19.42065,0,0,1,7.47389,0l-4.72035,3.93363Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#3f3d56"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M905.23855,524.438s-3.14691-7.4739,1.18009-8.26063a19.42065,19.42065,0,0,1,7.47389,0l-4.72035,3.93363Z",
    transform: "translate(-29.64695 -97.19896)",
    opacity: 0.1
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M883.60358,569.67478l-11.40752-.78673,1.96681,3.54027s-15.73452,4.72035-10.6208,18.0947a172.85111,172.85111,0,0,0,12.981,25.962l5.11372,9.83408s10.6208,1.57345,11.01416-1.57346,0-4.72035-1.96681-6.2938a9.6353,9.6353,0,0,1-3.14691-6.29381c0-1.57345.39337-3.14691-.78672-3.93363s-1.57345-1.96682-1.57345-4.327-4.327-11.01417-4.327-11.01417,13.76771-.39336,18.0947,3.14691,18.48806,16.9146,18.48806,16.9146a11.917,11.917,0,0,1,1.96681,2.75355c.78673,1.57345.78673,2.36017,2.36018,3.1469s.39336,3.93363,0,4.327S917.4328,639.3,917.4328,639.3s-4.327,7.4739.39336,7.86726,9.04735.78673,9.44071,0a21.38527,21.38527,0,0,1,1.57346-3.1469c1.18008-1.96682,0-6.29381,0-6.29381s11.40752-14.55443,7.86725-23.60178-11.01416-29.50222-11.01416-29.50222l-11.40752-4.72035-20.84824-7.4739Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#2f2e41"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M882.81686,624.35223s-2.36018,9.04735-3.14691,9.44071-9.44071,7.86726-3.54026,9.04735,10.22743.78673,11.40752-.39336.78673-2.36018,2.75354-2.75354,5.50709-1.57346,5.11372-4.327-2.36017-10.22743-3.54026-11.01416S882.81686,624.35223,882.81686,624.35223Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#2f2e41"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M917.03944,644.41374s-3.54027,2.75354-1.57346,7.86726,4.72036,10.6208,4.72036,10.6208,3.1469,9.83408,8.26062,8.26062a5.57728,5.57728,0,0,0,3.61728-4.22637,10.108,10.108,0,0,0-1.42857-8.22508l-2.97543-4.46315-3.14691-8.26063Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#2f2e41"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M907.20536,528.765s-4.72035-.39336-5.50708.78673-4.327,16.9146,0,18.48805,17.308,4.327,19.27479,2.36018,2.75354-19.27478,2.75354-19.27478Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#a0616a"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M907.20536,528.765s-4.72035-.39336-5.50708.78673-4.327,16.9146,0,18.48805,17.308,4.327,19.27479,2.36018,2.75354-19.27478,2.75354-19.27478Z",
    transform: "translate(-29.64695 -97.19896)",
    opacity: 0.1
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M900.12483,541.746s5.50708,5.50708,9.04735,4.72035,11.80089-4.327,12.58761-5.90044,10.6208-1.96682,10.6208-1.96682l-10.6208,29.50223,7.4739,24.78186s4.327-5.11372-7.4739-5.50708-27.53541-6.29381-30.28895-14.16107c0,0-17.308-2.36017-18.09469-2.75354S875.343,567.708,875.343,567.708l11.40753-3.1469,8.26062-10.6208Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#f2f2f2"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M903.6651,529.55176s1.96681-2.75355,0-2.75355a75.79482,75.79482,0,0,0-9.44072.39337c-1.96681.39336-9.44071-1.57345-10.22743.78672s-.78673,16.91461.78672,18.0947,2.36018,1.18009.39337,3.54027-6.68717,10.22743-5.50709,12.981-12.58761,3.54027-10.6208,6.68718a6.46091,6.46091,0,0,0,5.11372,3.1469s.78673-6.29381,5.50708-3.1469,11.01417,11.01416,16.12789,5.90044,7.08053-9.83407,7.47389-16.52124a55.67726,55.67726,0,0,0-.78672-14.9478C901.69828,539.77919,903.6651,529.55176,903.6651,529.55176Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#e87100"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M924.12,537.02565s3.1469,2.75354,0,9.44071-11.40753,22.42169-4.72036,32.64913,9.44072,12.981,7.86726,14.94779a7.641,7.641,0,0,0-1.57345,4.327l4.327-1.57345a49.50446,49.50446,0,0,1,2.36018-9.44071c1.57345-3.93363-3.1469-15.73452-3.1469-15.73452l1.57345-15.34115s6.29381-9.83408,7.08053-10.22744-1.57345-17.308-1.57345-17.308-3.93363-1.18009-5.90044,0S924.12,537.02565,924.12,537.02565Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#e87100"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M886.35712,528.37167H883.997l-16.12788,8.26062s-1.18009-5.11372-1.96682-3.93363-.39336,4.327-2.36018,5.11372-3.1469,1.96681,0,3.54026,3.54027.39337,3.54027,3.14691,2.36018,3.1469,4.327,2.36018,2.36018-1.18009,4.327-.39337.78673,1.96682,3.54027.78673,9.83408-.78673,9.83408-.78673Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#e87100"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M933.56068,529.55176l2.75354-.78673s8.26062.78673,10.22744.78673,3.93363-.39337,5.11372-.39337,7.08053-.78672,7.86726-1.57345,4.327-2.75354,4.72035-1.57345,4.72036,8.654.78673,12.19425-4.72036,1.96682-7.08054,3.54027-21.2416,4.72035-21.635,4.327S933.56068,529.55176,933.56068,529.55176Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#e87100"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 887.78585,
    cy: 435.4997,
    r: 11.80089,
    fill: "#a0616a"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M908.74891,533.17323a2.23517,2.23517,0,0,1,.24407.82588,3.08963,3.08963,0,0,0,2.95675,2.38211,1.8464,1.8464,0,0,0,1.60085,2.23545,10.17339,10.17339,0,0,0,1.75326-3.43285,3.15181,3.15181,0,0,1,.59242-1.34617,2.70281,2.70281,0,0,1,1.67965-.63134,88.32417,88.32417,0,0,1,9.46516-.70524,2.35308,2.35308,0,0,0,1.24447-.2544c.88928-.57316.59257-1.9552.03088-2.85176a8.92419,8.92419,0,0,0-4.75936-3.71378,22.5248,22.5248,0,0,0-4.38288-.72614,54.03807,54.03807,0,0,0-5.92473-.61519,9.69693,9.69693,0,0,0-5.66558,1.51524c-1.18275.83355-3.12382,3.16955-2.1741,4.64365.15208.236.63238.35237.83673.593.27808.32738.27934.82228.59525,1.11946C907.3691,532.70719,908.32536,532.54959,908.74891,533.17323Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#2f2e41"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M917.4328,513.03051s-13.37434,4.72036-12.19425,11.40753,4.72035,14.55443,12.19425,14.16106,11.40753-8.52854,11.40753-8.52854l-1.96682-11.1396S919.39961,513.03051,917.4328,513.03051Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#3f3d56"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M915.74513,536.63561s5.2581-5.70475,7.90524-2.3969C923.65037,534.23871,923.52993,534.07543,915.74513,536.63561Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#2f2e41"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M925.67306,682.49735c-7.05134,0-15.77562-2.336-24.27748-10.77907-20.8129-20.67076-40.58592-22.744-40.78318-22.76243l.07337-.78365c.20014.01883,20.25359,2.12047,41.26451,22.98753,10.79635,10.7226,21.94,11.37949,29.387,10.04152a36.72575,36.72575,0,0,0,13.76732-5.54857l.46481.6346a37.54469,37.54469,0,0,1-14.062,5.68264A32.845,32.845,0,0,1,925.67306,682.49735Z",
    transform: "translate(-29.64695 -97.19896)",
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 841.5657,
    cy: 563.53934,
    r: 4.72036,
    fill: "#2f2e41"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 875.00155,
    cy: 585.56767,
    r: 4.72036,
    fill: "#2f2e41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActive);
export default __webpack_public_path__ + "static/media/active.ad31de90.svg";
export { ForwardRef as ReactComponent };